import type { ScheduledMeeting } from '../types'

interface BookingStatusBannerProps {
  scheduledMeeting: ScheduledMeeting | null
  bookingConfirmed: boolean
  calendlyOwnerName?: string
}

export function BookingStatusBanner({ scheduledMeeting, bookingConfirmed, calendlyOwnerName }: BookingStatusBannerProps) {
  if (!scheduledMeeting) return null
  return (
    <div
      style={{
        margin: 16,
        padding: bookingConfirmed ? 16 : 0,
        backgroundColor: bookingConfirmed ? '#ecfdf5' : '#fff7ed',
        border: `2px solid ${bookingConfirmed ? '#10b981' : '#F5A623'}`,
        borderRadius: 12,
        textAlign: 'center',
        overflow: 'hidden',
      }}
    >
      {bookingConfirmed ? (
        <>
          <div style={{ fontWeight: 700, color: '#059669', marginBottom: 8, fontSize: 18 }}>
            ✅ הפגישה נקבעה בהצלחה!
          </div>
          <div style={{ fontSize: 15, color: '#374151', fontWeight: 500 }}>
            📅 {scheduledMeeting.formattedTime}
          </div>
          <div style={{ fontSize: 14, color: '#6b7280', marginTop: 4 }}>
            פגישה עם {calendlyOwnerName}
          </div>
          <div style={{ fontSize: 13, color: '#059669', marginTop: 8 }}>
            תקבל/י אישור במייל בקרוב
          </div>
        </>
      ) : (
        <>
          <div style={{ fontWeight: 700, color: '#F5A623', fontSize: 16 }}>
            📅 ממתין לאישור
          </div>
          <div style={{ fontSize: 15, color: '#374151', marginTop: 4 }}>
            פגישה עם {calendlyOwnerName}
          </div>
          <div style={{ fontSize: 13, color: '#6b7280', marginTop: 4 }}>
            {scheduledMeeting.formattedTime.split(' בשעה')[0]}
          </div>
          <div style={{ fontSize: 13, color: '#F5A623', marginTop: 8, fontWeight: 500 }}>
            👈 אשר/י את הפגישה בחלון משמאל
          </div>
        </>
      )}
    </div>
  )
}
